import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';
import { GUNCEL_AY, cozGuncelAy } from '../utils/guncelAy';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const YIL = new Date().getFullYear();

const empty = {
  isletme_id: '', yil: YIL, ay: new Date().getMonth() + 1,
  erkek_bas: 0, disi_bas: 0, erkek_yavru: 0, disi_yavru: 0,
  dogum_sayisi: 0, satis_sayisi: 0, olum_sayisi: 0, aciklama: ''
};

export default function AsyaCeylani() {
  const [kayitlar,   setKayitlar]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [ozet,       setOzet]       = useState<any>(null);
  const [secili,     setSecili]     = useState<any>(null);
  const [modalAcik,  setModalAcik]  = useState(false);
  const [form,       setForm]       = useState<any>({ ...empty });
  const [filtre,     setFiltre]     = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || GUNCEL_AY
    };
  })());
  const [hata,       setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol);

  const [kiralikGoster, setKiralikGoster] = useState(false);

  useEffect(() => {
    if (!isGM && user?.isletme_id) setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const [cozulenAy, setCozulenAy] = useState<number | null>(null);

  const yukle = async () => {
    let ay: any = filtre.ay;
    if (ay === GUNCEL_AY) {
      ay = await cozGuncelAy(filtre.yil, filtre.isletme_id, (params: any) =>
        axios.get(`${API}/api/ceylan/`, { headers: headers(), params }));
      setCozulenAy(ay);
    } else {
      setCozulenAy(null);
    }
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    if (ay) p.ay = ay;
    axios.get(`${API}/api/ceylan/`, { headers: headers(), params: p })
      .then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
    axios.get(`${API}/api/ceylan/ozet`, { headers: headers(), params: p })
      .then(r => setOzet(r.data)).catch(() => setOzet(null));
  };

  const toplam = (f: any) => (Number(f.erkek_bas) || 0) + (Number(f.disi_bas) || 0) +
                              (Number(f.erkek_yavru) || 0) + (Number(f.disi_yavru) || 0);

  const yeniAc = () => {
    const isletme_id = isGM ? '' : user?.isletme_id;
    setForm({ ...empty, isletme_id }); setSecili(null); setHata(''); setModalAcik(true);
  };

  const duzenleAc = (k: any) => { setSecili(k); setForm({ ...k }); setHata(''); setModalAcik(true); };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const body = { ...form, isletme_id: Number(form.isletme_id) };
      if (secili) {
        await axios.put(`${API}/api/ceylan/${secili.id}`, body, { headers: headers() });
      } else {
        await axios.post(`${API}/api/ceylan/`, body, { headers: headers() });
      }
      yukle(); setModalAcik(false); setSecili(null);
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Silmek istiyor musunuz?')) return;
    try {
      await axios.delete(`${API}/api/ceylan/${id}`, { headers: headers() });
      yukle();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Silme işlemi başarısız oldu');
    }
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) { try { await axios.delete(`${API}/api/ceylan/${k.id}`, { headers: headers() }); } catch {} }
    yukle();
  };

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');

  const ceylanColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong> – {k.isletme_ad}</>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'erkek', label: 'Erkek Ceylan', sortable: true, render: (k: any) => n(k.erkek_bas), sortValue: (k: any) => Number(k.erkek_bas || 0) },
    { key: 'disi', label: 'Dişi Ceylan', sortable: true, render: (k: any) => n(k.disi_bas), sortValue: (k: any) => Number(k.disi_bas || 0) },
    { key: 'erkek_yavru', label: 'Erkek Yavru', sortable: true, render: (k: any) => n(k.erkek_yavru), sortValue: (k: any) => Number(k.erkek_yavru || 0) },
    { key: 'disi_yavru', label: 'Dişi Yavru', sortable: true, render: (k: any) => n(k.disi_yavru), sortValue: (k: any) => Number(k.disi_yavru || 0) },
    { key: 'toplam', label: 'Toplam', sortable: true, render: (k: any) => <strong>{n(k.toplam_bas)}</strong>, sortValue: (k: any) => Number(k.toplam_bas || 0) },
    { key: 'dogum', label: 'Doğum', sortable: true, render: (k: any) => n(k.dogum_sayisi), sortValue: (k: any) => Number(k.dogum_sayisi || 0) },
    { key: 'satis', label: 'Satış', sortable: true, render: (k: any) => n(k.satis_sayisi), sortValue: (k: any) => Number(k.satis_sayisi || 0) },
    { key: 'olum', label: 'Ölüm', sortable: true, render: (k: any) => n(k.olum_sayisi), sortValue: (k: any) => Number(k.olum_sayisi || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  const inp = (field: string) => ({
    className: 'form-control', type: 'number' as const, value: form[field] ?? 0,
    onChange: (e: any) => setForm({ ...form, [field]: Number(e.target.value) })
  });

  return (
    <div>
      <div className="page-header">
        <h1>🦌 Asya Ceylanı</h1>
        <p>İşletme bazında Asya ceylanı varlık ve üretim verileri – Ceylanpınar ve Altınova İşletmeleri</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">🦌</div>
            <div><div className="stat-value">{n(ozet.toplam_bas)}</div><div className="stat-label">Toplam (Baş)</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🐣</div>
            <div><div className="stat-value">{n(ozet.toplam_dogum)}</div><div className="stat-label">Doğum</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div><div className="stat-value">{n(ozet.toplam_satis)}</div><div className="stat-label">Satış (Baş)</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">📋</div>
            <div><div className="stat-value">{n(ozet.kayit_sayisi)}</div><div className="stat-label">Kayıt Sayısı</div></div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value={GUNCEL_AY}>Güncel Ay{cozulenAy ? ` (${AYLAR[cozulenAy]})` : ''}</option>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 220 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <button className="btn btn-success" onClick={yeniAc}>+ Yeni Kayıt</button>
        </div>
        <DataTable columns={ceylanColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="asya-ceylani" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 540 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🦌 Asya Ceylanı Kaydı</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-row">
                {isGM && (
                  <div className="form-group">
                    <label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id}
                      onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Yıl *</label>
                  <input className="form-control" type="number" value={form.yil}
                    onChange={e => setForm({ ...form, yil: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ay *</label>
                  <select className="form-control" value={form.ay}
                    onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a5276', marginBottom: 8, marginTop: 4 }}>Hayvan Varlığı</div>
              <div className="form-row">
                <div className="form-group"><label>Erkek Ceylan</label><input {...inp('erkek_bas')} /></div>
                <div className="form-group"><label>Dişi Ceylan</label><input {...inp('disi_bas')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Erkek Yavru Ceylan</label><input {...inp('erkek_yavru')} /></div>
                <div className="form-group"><label>Dişi Yavru Ceylan</label><input {...inp('disi_yavru')} /></div>
              </div>
              <div style={{ background: '#f0f7ff', borderRadius: 8, padding: '8px 14px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13, color: '#555' }}>Toplam (Baş)</span>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#1a5276' }}>{n(toplam(form))}</span>
              </div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a5276', marginBottom: 8 }}>Hareketler</div>
              <div className="form-row">
                <div className="form-group"><label>Doğum</label><input {...inp('dogum_sayisi')} /></div>
                <div className="form-group"><label>Satış</label><input {...inp('satis_sayisi')} /></div>
                <div className="form-group"><label>Ölüm</label><input {...inp('olum_sayisi')} /></div>
              </div>
              <div className="form-group">
                <label>Açıklama</label>
                <textarea className="form-control" value={form.aciklama}
                  onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
